/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useMemo, useState, type ReactNode } from "react";
import { ErrorHandlerContext } from "./ErrorHandlerContext";
import { CenterScreenModal } from "@/components/atoms";

const formatErrorMessage = (err: unknown): string => {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  return "An unexpected error occurred";
};

export const ErrorHandlerContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const close = useCallback(() => {
    setIsOpen(false);
    setError(null);
  }, []);

  const open = useCallback((err: unknown) => {
    setError(err);
    setIsOpen(true);
  }, []);

  const value = useMemo(
    () => ({ close, open, isOpen, error }),
    [close, open, isOpen, error]
  );

  return (
    <ErrorHandlerContext.Provider value={value}>
      {children}
      <CenterScreenModal isOpen={isOpen} onClose={close}>
        <div className="max-w-md space-y-4 pr-8">
          <h2 className="text-lg font-semibold text-slate-900">Error</h2>
          <p className="text-sm text-slate-700 whitespace-pre-wrap">
            {formatErrorMessage(error)}
          </p>
          <button
            type="button"
            onClick={close}
            className="rounded-lg bg-primary1 px-4 py-2 text-sm font-semibold text-white"
          >
            Cerrar
          </button>
        </div>
      </CenterScreenModal>
    </ErrorHandlerContext.Provider>
  );
};
